/**
 * Table sorter setup.
 * Exported so prime-core.js (which contains postProcessPrimeData) can import
 * and call initializeTableSorter after AJAX responses.
 */

export function setupTableSorter($table, initialSortColumn) {
  return $table.tablesorter({
    sortList        : [[initialSortColumn, 1]],
    sortInitialOrder: 'desc',
    widgets         : ['filter'],
    widgetOptions   : {
      filter_external      : '.search',
      filter_defaultFilter : { 1: '~{query}' },
      filter_columnFilters : false,
      filter_placeholder   : { search: 'Søk...' },
      filter_saveFilters   : true,
      filter_reset         : '.reset',
    },
  })
  .on('sortStart', () => {
    window.disableHeaderAnim = true;
  })
  .on('sortEnd', function(e) {
    const $target    = $(e.target);
    const $container = $target.closest('.prime-stats-table-container');

    if ($container.hasClass('-lock-to-viewport')) {
      let totalWidth = 0;
      $target.find('.tablesorter-headerRow:not(.-is-spacer-row) th').each(function(i) {
        const width = $('.tablesorter-headerRow.-is-spacer-row th').eq(i).outerWidth();
        $(this).css('width', width + 'px');
        totalWidth += width;
      });
      $target.find('.tablesorter-headerRow:not(.-is-spacer-row)').css('width', totalWidth + 'px');
    }

    let i = 1;
    $target.find('tbody tr').each(function() {
      $(this).find('th > span.number').text(i + '.');
      i++;
    });
  });
}

export function setupPager($table, $pagerContainer, pageSize = 20) {
  const rowCount = $table.find('tbody tr').length;
  if (rowCount <= pageSize) {
    $pagerContainer.remove();
    return;
  }

  const pagerOptions = {
    container      : $pagerContainer,
    size           : pageSize,
    output         : '{startRow} til {endRow} / {filteredRows}',
    savePages      : false,
    storageKey     : 'tablesorter-pager',
    pageReset      : 0,
    fixedHeight    : false,
    removeRows     : false,
    countChildRows : false,
    cssNext        : '.next',
    cssPrev        : '.prev',
    cssFirst       : '.first',
    cssLast        : '.last',
    cssGoto        : '.gotoPage',
    cssPageDisplay : '.pagedisplay',
    cssPageSize    : '.pagesize',
    cssDisabled    : 'disabled',
    cssErrorRow    : 'tablesorter-errorRow',
  };

  $table.tablesorterPager(pagerOptions);

  $('.clear-pager-data').click(() => {
    $.tablesorter.storage($table, 'tablesorter-pager', '');
  });

  $('.goto').click(() => {
    $table.trigger('pageAndSize', [1, pageSize]);
  });
}

function initializeTableBlock($container, selector, pagerSelector, isTeamStats, initialCol, activeCol) {
  const $table = $container.find(`table.${selector}`);
  if (!$table.length) return;

  const $pager   = $container.find(pagerSelector);
  const colInit  = isTeamStats ? initialCol - 1 : initialCol;
  const colActive = isTeamStats ? activeCol - 1 : activeCol;

  setupTableSorter($table, colInit);
  if ($pager.length) {
    $pager.each(function() {
      setupPager($table, $(this));
    });
  }
  $table.find(`tbody td:nth-child(${colActive + 1})`).addClass('-is-sorted');
}

export function initializeTableSorter(oTheContainer) {
  const $container = $(oTheContainer);
  const isTeamStats = $container.find('.prime-match-pitch-stats-table').hasClass('stats_team');

  initializeTableBlock($container, 'prime-match-pitch-stats-table', '.pitch.pager',  isTeamStats, 3, 4);
  initializeTableBlock($container, 'prime-match-goalie-stats-table', '.goalie.pager', isTeamStats, 2, 3);
}



// WEBPACK FOOTER //
// ./scripts/routes/common/stats-table.js